import { Component, OnInit } from '@angular/core';

import { Router } from '@angular/router';
import { takeWhile } from 'rxjs/operators';
import { AuthService } from '../../services/auth.service'

@Component({
  selector: 'app-callback',
  templateUrl: './callback.component.html',
  styleUrls: ['./callback.component.scss'],
  standalone: false,
})
export class CallbackComponent implements OnInit {
  profile = null;

  constructor(
    private authService: AuthService,
    private router: Router
  ) {}

  ngOnInit() {
    this.authService.user$
      .pipe(takeWhile(() => this.profile === null))
      .subscribe((p) => {
        this.profile = p;
      });
  }
}
